import { render, staticRenderFns } from "./customer-code-view.vue?vue&type=template&id=d2ba9c70&scoped=true&"
import script from "./customer-code-view.vue?vue&type=script&lang=ts&"
export * from "./customer-code-view.vue?vue&type=script&lang=ts&"
import style0 from "./customer-code-view.vue?vue&type=style&index=0&id=d2ba9c70&lang=scss&scoped=true&"
import style1 from "./customer-code-view.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ba9c70",
  null
  
)

export default component.exports